import {
  Alert,
  Avatar,
  Button,
  Col,
  Flex,
  Image,
  message,
  Row,
  Space,
  Spin,
  Tag,
  Popover,
  Divider,
} from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import {
  IconCheckLight,
  IconLeft,
  IconPendingStep,
  IconRight,
  IconPerson,
  IconUnpaidStep,
  IconConfirmedStep,
  IconPickupStep,
  IconRejectLight,
  IconCarDelivery,
  IconPhoneDeli,
  IconDeliFree,
  IconPendingRefunded,
  IconSuccessRefunded,
  IconQRCode,
  IconDownloadQR
} from "../../../assets/icons";
import api from "../../../api/api";
import { getFormattedNumber } from "../../../utils";
import moment from "moment";
import { ORDER_STATUS } from "../../../constants";
import CheckModal from "./CheckModal/CheckModal";
import { PRIVATE_ROUTE } from "../../../route.constants";
import RejectReasonModal from "./RejectReasonModal/RejectReasonModal";
import PickupModal from "./PickupModal/PickupModal";
import RejectModal from "./RejectModal/RejectModal";
import { CopyOutlined, PrinterFilled } from "@ant-design/icons";
import { CircleInformation, IconCOD } from "../../../assets/PaymentIcon";
 import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import DeliRequestModal from "./DeliRequestModal/DeliRequestModal";
import DeliveryRequestModal from "../../OrderManagement/OrderDetails/DeliveryRequestModal/DeliveryRequestModal";
import RefundConfirmModal from "./RefundOrderModal/RefundConfirmModal";
import { Trans, useTranslation } from "react-i18next";
import ViewQRReceiptModal from "./ViewQRReceiptModal";


const RootContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Topbar = styled.div`
  padding-top: 8px;
  display: flex;
  gap: 18px;
  align-items: center;
  justify-content: start;

  .ant-btn-default {
    height: 48px;
    padding: 0 12px !important;
    border: none !important;
    background: ${(props) => props.theme.backgroundColor} !important;
    color: ${(props) => props.theme.primaryColor} !important;
  }

  .ant-btn-primary {
    width: 172px;
    height: 48px;
  }
flex-wrap:wrap;
  @media (max-width: 480px){
   flex-wrap:wrap;

  }

`;

const TitleWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 400;
  color: #1d1014;
  line-height: 1;
`;

const GrayTitle = styled(Title)`
  color: #868686;
`;

const StatusCard = styled.div`
  padding: 24px 20px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  border-radius: 8px;
  background: ${(props) => props.theme.primaryColor};
  color: #fff;

  .ant-space {
    flex: 1;
  }

  > svg {
    max-width: 40%;
  }
     @media (max-width: 480px){
  flex-direction:column;
  > svg {
    max-width: 100%;
  }
  }
`;

const RefundedStatusCard = styled.div`
  padding: 24px 20px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  border-radius: 8px;
  background: ${({ refundedStatus }) => (refundedStatus ? "#319300" : "#CB8600")};
  color: #fff;

  .ant-space {
    flex: 1;
  }

  > svg {
    max-width: 40%;
  }
   @media (max-width: 480px){
  flex-direction:column;
  > svg {
    max-width: 100%;
  }
  }
`;

const StatusTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #fff;
`;

const StatusText = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #fff;
`;

const CancelledStatusCard = styled(StatusCard)`
  background: #ffc2c5;

  ${StatusTitle} {
    color: #f00 !important;
  }

  ${StatusText} {
    color: #f00 !important;
    // text-transform: lowercase;
  }
`;

const Card = styled.div`
  height: 100%;
  padding: 20px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 8px;
  background: #f7f7f7;

  .ant-descriptions-item {
    padding-bottom: 8px !important;
    color: #1d1014;
    font-size: 14px;
    font-weight: 400;
  }

  .ant-descriptions-item-label {
    font-size: 14px;
    font-weight: 700;
    color: #1e1e1e;
  }

  .ant-descriptions-item-content {
    font-size: 14px;
    font-weight: 400;
    color: #1d1014;
  }

  .ant-btn-primary {
    min-width: 172px;
    height: 48px;
  }

  .ant-btn-default {
    min-width: 172px;
    height: 48px;
    border: 1px solid #ffc8c8 !important;
    background: #ffe6e8 !important;
    color: #f00 !important;

    :hover {
      background: #ffe6e8 !important;
    }
  }

  .ant-btn-ghost {
    min-width: 172px;
    height: 48px;
    border: 1px solid #ffc8c8 !important;
    background: #ff0000 !important;
    color: #fff !important;
    font-weight: 600 !important;
    font-size: 16px !important;

    :hover {
      background: #ff0000 !important;
    }
  }

  .ss-image {
    width: 80px;
    aspect-ratio: 1;
    border-radius: 8px;
  }

  .icon-right {
    cursor: pointer;
    position: absolute;
    right: -8px;
    top: -5px;
  }

  .custom-avatar {
    border: 1px solid #b9b9b9;
    border-radius: 8px;
    background: ${(props) => props.theme.backgroundColor};
  }
`;

const BoldText = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #1e1e1e;
  white-space: nowrap;
  line-height: 2;
`;

const NormalText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #1d1014;
  line-height: 2;
`;

const CancelledText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #f00;
  background: #ffe6e8;
  border-radius: 8px;
  padding: 2px 8px;
`;

const PrimaryText = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${(props) => props.theme.primaryColor};
`;

const GrayText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #868686;
  // white-space: nowrap;
  line-height: 2;
`;

const GrayTextHref = styled.a`
  font-size: 14px;
  font-weight: 400;
  color: #1859Ff;
  cursor:pointer;
  line-height: 2;
`;

const SpinWrapper = styled.div`
  text-align: center;
  padding-top: 24px;
`;

const HiddenInUI = styled.div`
  position: absolute;
  left: -9999px;
  top: -9999px;
  opacity: 0;
`;

const PrintWrapper = styled.div`
  width: 90mm;
  margin: 0 auto;
  background: #fff;
  height:100vh;
`;

const Receipt = styled.div`
  font-family: monospace;
  font-size: 12px;
  padding: 12px;
  color: #000;
`;

const Center = styled.div`
  text-align: center;
`;

const PrintRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 4px 0;
`;

const Hr = styled.hr`
  border: none;
  border-top: 1px dashed #000;
  margin: 6px 0;
`;

const BoldRow = styled(PrintRow)`
  font-weight: 700;
`;

/* PRINT ONLY CONTROL */
const PrintStyle = styled.div`
  @media print {
    body * {
      visibility: hidden;
    }

    #print-receipt,
    #print-receipt * {
      visibility: visible;
    }

    #print-receipt {
      position: absolute;
      left: 0;
      top: 0;
    }

    @page {
      size: 80mm auto;
      margin: 0;
    }
  }
`;

const CardResponsive = styled.div`
 display: flex;
 justify-content:space-between;
 width: 100%;
 align-items:start;
 gap:10px;
 @media (max-width: 750px){
  flex-direction:column;
 }
`
const DeliDiv = styled.div`
  margin-bottom: -30px;
  background-color: #fffbe7;
  width: 100%;
  padding: 8px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;

  @media (max-width: 480px) {
    flex-direction:column;
    justify-content:start;
    align-items:center;
    margin-bottom: -15px;
  }
`;

const getStatus = (status,t,statusParam,refundedStatus) => {
   if ((["CANCELLED","COMPLETED"].includes(status)) && statusParam === "REFUNDED" && refundedStatus) {
    return {
      label: t('refunded_success'),
      text: t('refunded_success_text'),
      icon: <IconSuccessRefunded />,
    };
  }
  if ((["CANCELLED","COMPLETED"].includes(status)) && statusParam === "REFUNDED") {
    return {
      label: t('pending_refunded'),
      text: t('refunded_pending_text'),
      icon: <IconPendingRefunded />,
    };
  }
  switch (status) {
    case ORDER_STATUS.PENDING:
      return {
        label: t('pending'),
        text: t('pending_text'),
        icon: <IconPendingStep />,
      };
    case ORDER_STATUS.UNPAID:
      return {
        label: t('unpaid'),
        text: t('unpaid_text'),
        icon: <IconUnpaidStep />,
      };
    case ORDER_STATUS.CONFIRMED:
      return {
        label: t('order_confirmed'),
        text: t('confirmed_text'),
        icon: <IconConfirmedStep />,
      };
    case ORDER_STATUS.CANCELLED:
      return {
        label: t('order_cancelled'),
        text: t('cancelled_text'),
      };
    case ORDER_STATUS.COMPLETED:
      return {
        label: t('completed_success_order'),
        text: t('completed_text'),
        icon: <IconPickupStep />,
      };
      case ORDER_STATUS.DELIVERY_ORDER:
      return {
        label: t('completed_success_order'),
        text: t('completed_text'),
        icon: <IconPickupStep />,
      };
      
  }
};

const StatusBox = ({ status,cancelled_by }) => {
  return (
    <StatusCard>
      <Space direction="vertical" size={"small"}>
        <StatusTitle>{status.label}</StatusTitle>
        <StatusText>{status.text}</StatusText>
      </Space>
      {status.icon}
    </StatusCard>
  );
};

const RefundedStatusBox = ({ status,refundedStatus }) => {
  return (
    <RefundedStatusCard refundedStatus={refundedStatus}>
      <Space direction="vertical" size={"small"}>
        <StatusTitle>{status.label}</StatusTitle>
        <StatusText>{status.text}</StatusText>
      </Space>
      {status.icon}
    </RefundedStatusCard>
  );
};

const CancelledStatusBox = ({ status, cancel_reason, cancelled_by,cancelType }) => {
  return (
    <CancelledStatusCard>
      <Space direction="vertical" size={"small"}>
        <StatusTitle>{status.label}</StatusTitle>
        <StatusText>{`${(cancelType === "AUTO_CANCEL" && cancelled_by === null) ? "Your order is auto rejected due to nonpayment for more than 24 hours." : (cancelled_by === null ? `${status.text} user` : `${status.text} admin`)}${
          cancel_reason ? ` ${cancel_reason}` : ""
        }.`}</StatusText>
      </Space>
    </CancelledStatusCard>
  );
};

const getLanguageKey = (language) => {
  const normalizedLanguage = String(language || "")
    .toLowerCase()
    .trim();

  if (
    normalizedLanguage === "zh" ||
    normalizedLanguage === "zh-cn" ||
    normalizedLanguage === "chinese"
  ) {
    return "zh";
  }

  if (
    normalizedLanguage === "mm" ||
    normalizedLanguage === "my" ||
    normalizedLanguage === "my-mm" ||
    normalizedLanguage === "myanmar" ||
    normalizedLanguage === "burmese"
  ) {
    return "mm";
  }

  if (
    normalizedLanguage === "en" ||
    normalizedLanguage === "en-us" ||
    normalizedLanguage === "english"
  ) {
    return "en";
  }

  return normalizedLanguage;
};

const getDisplayLanguage = (currentLanguage, storeLanguages = []) => {
  const availableLanguages = storeLanguages
    .map((item) => getLanguageKey(item?.language))
    .filter(Boolean);

  const selectedLanguage = getLanguageKey(currentLanguage);

  // Store does not have language information.
  // Keep English as the fallback.
  if (!availableLanguages.length) {
    return selectedLanguage || "en";
  }

  // Current selected language exists in the store.
  if (availableLanguages.includes(selectedLanguage)) {
    return selectedLanguage;
  }

  // Current language does not exist in the store.
  // Use the first language configured in panel info.
  return availableLanguages[0];
};

const getLocalizedValue = (value, language) => {
  if (value === null || value === undefined) {
    return "-";
  }

  // Normal string / number
  if (typeof value !== "object") {
    return value;
  }

  const languageFieldMap = {
    zh: "primary",
    mm: "secondary",
  };

  const field = languageFieldMap[language];

  // Use requested language first.
  if (field && value[field]) {
    return value[field];
  }

  // Fallback order:
  // primary -> secondary
  return value.primary || value.secondary || "-";
};


const OrderDetails = () => {
  const navigate = useNavigate();
const { status: statusParam, id } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [status, setStatus] = useState({});
  const [openCheck, setOpenCheck] = useState(false);
  const [openRejectReasonModal, setOpenRejectReasonModal] = useState(false);
  const [openPickupModal, setOpenPickupModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [cancelType, setCancelType] = useState("");
  const [product, setProduct] = useState({});
  const [open, setOpen] = useState(false);
  const [deliveryModalOpen, setDeliveryModalOpen] = useState(false);
  const [openRefundModal, setOpenRefundModal] = useState(false);
  const [businessInfoData, setBusinessInfoData] = useState(null);
  const [checkQR, setCheckQR] = useState(false);
  const [storeCurrency,setStoreCurrency] = useState();


const { t, i18n } = useTranslation();

  const params = useParams(); 
  
  const currentLanguage =
  i18n.resolvedLanguage || i18n.language || "en";

const displayLanguage = getDisplayLanguage(
  currentLanguage,
  storeCurrency?.storeLanguages
);

  const [qrModalOpen, setQrModalOpen] = useState(false);
const [qrImage, setQrImage] = useState(null);
const [qrLoading, setQrLoading] = useState(false);

  const refundedStatus = (data?.payment_type === "AUTO"  && data?.base_refund_amount > 0);

  const checkQRScan = () => {
        api
          .checkQRScan()
          .then(({ data }) => {
            setCheckQR(data?.status === "ACTIVE" ? true : false);
          })
          .catch((error) => {
            message.error(error);
          });
      };

   const getBusinessInformation = () => {
      api
        .getBusinessInformation()
        .then(({ data }) => {
          setLoading(false);
          setBusinessInfoData(data);
        })
        .catch((error) => {
          message.error(error);
        });
    };

 useEffect(() => {
    getBusinessInformation();
    checkQRScan();
  }, []);

  useEffect(() => {
    getOrderDetails(id);

    // eslint-disable-next-line
  }, [id]);

  

  const getOrderDetails = (id) => {
    setLoading(true);
    api
      .getOrderDetails(id)
      .then(({ data }) => {
        setLoading(false);
        setData(data);
        setStatus(getStatus(data.status,t,statusParam,refundedStatus));
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const totalPriceContent = (
  <div style={{width:"320px",borderRadius:"8px",padding:"8px 6px"}}>
    <h4 style={{fontSize:"16px",color:"#191114",fontWeight:"700"}}>
      {t('additional_cod')}
    </h4>

    <p className="text-sm leading-5 text-gray-600">
      {t('cod_info_text')}
    </p>
  </div>
);


  const handleCheckClicked = () => {
    setOpenCheck(true);
  };

  const handleCancelClicked = () => {
    setOpenRejectReasonModal(true);
    setCancelType("all");
  };

  const handleRejectReasonClose = () => {
    setOpenRejectReasonModal(false);
  };

  const handleConfirmClicked = () => {
    setOpenCheck(true);
  };

  const handleRejectClicked = () => {
    setOpenRejectModal(true);
  };

  const handlePickupClicked = () => {
    setOpenPickupModal(true);
  };

  const handlePickupClose = () => {
    setOpenPickupModal(false);
  };

  const handleRejectClose = () => {
    setOpenRejectModal(false);
  };

  const handleRefundClose = () => {
    setOpenRefundModal(false);
  };


  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      message.success(t('copy_to'));
    });
  };

  const successCallback = () => {
    getOrderDetails(id);
  };

  const goToProductDetails = (product_id) => {
    navigate(
      `/${PRIVATE_ROUTE.HOME}/${PRIVATE_ROUTE.PRODUCT_DETAILS}/${product_id}`
    );
  };

  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
  if (data?.status) {
    setStatus(getStatus(data.status, t,statusParam,refundedStatus));
  }
}, [data, t]);

  const Loader = () => (
    <SpinWrapper>
      <Spin />
    </SpinWrapper>
  );

  const items = [
     {
      key: 1,
      label: t('customer_name'),
      children: data?.user?.custom_name,
    },
     {
      key: 1,
      label: t('customer_id'),
      children: data?.user?.username,
    },
    {
      key: 1,
      label: t('order_id'),
      children: data?.order_id,
    },
    {
      key: 2,
      label: t('created_at'),
      children: moment(data?.created_at).format("DD MMM YYYY, HH:mm"),
    },
    {
      key: 3,
      label: t('status'),
      children: status.label,
    },
  ];

  const ActionButtons = ({ status }) => {
    switch (status) {
      case ORDER_STATUS.PENDING:
        return (
          <Button
            type="primary"
            icon={<IconCheckLight />}
            onClick={handleCheckClicked}
          >
            {t('check')}
          </Button>
        );
      case ORDER_STATUS.CONFIRMED:
        return (
          <Space>
            <Button disabled={data?.has_delivery_request} type="default" onClick={handleCancelClicked}>
              {t('cancel_order')}
            </Button>
            <Button
              type="primary"
              icon={<IconCheckLight />}
              onClick={handlePickupClicked}
            >
              {t('pickup')}
            </Button>
          </Space>
        );
      case ORDER_STATUS.UNPAID:
        return (
          <Space>
             {(data?.status === "PAYMENT_PENDING" && data?.payment_type === "AUTO") ? <></> :
            <Button
              type="primary"
              icon={<IconCheckLight />}
              onClick={handleConfirmClicked}
            >
              {t('confirm')}
            </Button>
            }
            <Button
              type="ghost"
              icon={<IconRejectLight />}
              onClick={handleRejectClicked}
            >
              {t('reject')}
            </Button>
          </Space>
        );
    }
  };

const totalQuantity = data?.OrderProducts?.reduce((acc, p) => {
  return p.is_cancel ? acc : acc + p.quantity;
}, 0);


const normalizeUrl = (url) => {
  if (!url) return null;
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
};

const mapLink = normalizeUrl(data?.pickup_address?.map_link);


 const getPanelInfo = () => {
    api
      .getPanelInfo()
      .then(({ data }) => {
        setStoreCurrency(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  useEffect(() => {
      getPanelInfo();
  }, []);
  

const previewReceipt = async () => {
  const element = document.getElementById("print-receipt");
  if (!element) return;

  const canvas = await html2canvas(element, {
  scale: 3,
  useCORS: true,
  allowTaint: true,
});
  const imgData = canvas.toDataURL("image/png");

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [80, (canvas.height * 100) / canvas.width],
  });

  const pdfWidth = 80;
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

  const blob = pdf.output("blob");
  const url = URL.createObjectURL(blob);

  window.open(url, "_blank");
};

const fullAddress = [
  data?.delivery_address?.address,
  data?.delivery_address?.township?.name?.primary,
  data?.delivery_address?.city?.name?.primary,
  data?.delivery_address?.country?.name?.primary,
].filter(Boolean)
.join(", ");

const base_final_income_amount =
  data?.cancelled_by === null
    ? Number(data?.base_customer_paid || 0) +
      Number(data?.base_cod_fee || 0) -
      Number(data?.base_refund_amount || 0)
    : Number(data?.base_final_amount || 0) +
      Number(data?.base_cod_fee || 0);


const final_income_amount =
  data?.cancelled_by === null
    ? Number(data?.customer_paid || 0) +
      Number(data?.cod_fee || 0) -
      Number(data?.refund_amount || 0)
    : Number(data?.final_amount || 0) +
      Number(data?.cod_fee || 0);

const base_cancelled_amount = Number(data?.base_customer_paid || 0) - Number(data?.base_final_amount || 0);

const cancelled_amount = Number(data?.customer_paid || 0) - Number(data?.final_amount || 0);


const handleGenerateQR = async () => {
  if (!id) return;
  try {
    const response = await api.generateQRScan({
      order_id: id,
    });

    const image = response?.data?.order_qr || null;

    if (!image) {
      message.error(t("qr_not_available"));
      return;
    }

    setQrImage(image);
    setQrModalOpen(true);
  } catch (error) {
    message.error(
      error?.response?.data?.message ||
      error?.message ||
      t("failed_load_qr")
    );
  } finally {
    setQrLoading(false);
  }
};

const handleDownloadQR = async () => {
  if (!data?.order_id) return;

  try {
    let image = qrImage;

    // If QR hasn't been generated yet, generate it first
    if (!image) {
      setQrLoading(true);

      const response = await api.generateQRScan({
        order_id: id,
      });

      image = response?.data?.order_qr;

      setQrImage(image);
    }

    if (!image) {
      message.error(t("qr_not_available"));
      return;
    }

    const link = document.createElement("a");
    link.href = image;
    link.download = `${data.order_id}.png`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    message.success(t("download_success"));
  } catch (error) {
    message.error(
      error?.response?.data?.message ||
      error?.message ||
      t("failed_download_qr")
    );
  } finally {
    setQrLoading(false);
  }
};


return (
    <RootContainer>
      <PrintStyle />
      <HiddenInUI>
      <div id="print-receipt">
        <PrintWrapper>
          <Receipt>
            <div style={{width:"100%",display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column"}}>
              <h3 style={{textAlign:"center"}}>{data?.store_data?.name?.primary}</h3><br/>
                <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:"8px",justifyContent:"center",width:"100%"}}>            
              <strong style={{textAlign:"center"}}>{businessInfoData?.address ? `${businessInfoData?.address?.primary}` : ""}</strong>
           <strong
              style={{
                textAlign: "center",
                display: "flex",
                gap: "4px",
                alignItems: "center",
                flexWrap: "wrap",
                marginBottom:"5px"
              }}
            >
              {businessInfoData?.phone?.length > 0 && (
                <>
                  <span>{t('phone')}:</span>
                  <span>{businessInfoData.phone.join(", ")}</span>
                </>
              )}
            </strong>
            </div> 
            </div>
            <Hr />
            <PrintRow>
              <span>{t('order_id')}:</span>
              <span>{data?.order_id}</span>
            </PrintRow>

            <PrintRow>
              <span>{t('date_time')}:</span>
              <span>{moment(data?.created_at).format("DD MMM YYYY, HH:mm")}</span>
            </PrintRow>
            <Hr />
            {data?.OrderProducts?.map((p, i) => {
            const variants = p?.variant?.ProductVariantCombinations;
            return (
              <div key={i}>
                <PrintRow>
                  <span
                    style={{
                      textDecoration: p?.is_cancel ? "line-through" : "none",
                    }}
                  >
                    {p.product.name.primary}
                  </span>

                  <span
                    style={{
                      whiteSpace: "nowrap",
                      paddingLeft: "5px",
                      textDecoration: p?.is_cancel ? "line-through" : "none",
                    }}
                  >
                    {getFormattedNumber(p.price)} {storeCurrency?.currency?.name} x {p.quantity}
                  </span>
                </PrintRow>
                {variants?.length > 0 && (
                  <div
                    style={{
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      flexWrap: "wrap",
                    }}
                  >
                    {variants.map((v, index) => (
                      <span style={{
                      textDecoration: p?.is_cancel ? "line-through" : "none",
                    }} key={index}>
                         {index === 0 && "-"} {v?.variant_attribute?.name}: {v?.variant_value?.name}
                        {index !== variants.length - 1 && ","}
                      </span>
                    ))}
                  </div>
                )}
                {p?.cancellation_reason !== null  && (
                  <div
                    style={{
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      flexWrap: "wrap",
                    }}
                  > 
                      <span>
                       {t('cancel_reason')}: {p?.cancellation_reason?.primary}
                      </span>
                  </div>
                )}
              </div>
            );
          })}
            <Hr/>
           <BoldRow>
              <span>{t('total_q')}:</span>
              <span>{totalQuantity}</span>
            </BoldRow>
              <Hr />
            <BoldRow>
              <span>Subtotal:</span>
              <span>{getFormattedNumber(data?.total_price)} {storeCurrency?.currency?.name}</span>
            </BoldRow>
            {data?.payment_type !== "COD" &&
              <BoldRow>
              <span>{t('refund_Amt')}:</span>
              <span style={{color:"#FF3F33"}}>{data?.refund_amount === ("0" || null) ? "" : "-"} {getFormattedNumber(data?.refund_amount)} {storeCurrency?.currency?.name}</span>
            </BoldRow>}
           <BoldRow>
              <span>{t('total')}:</span>
              <span>{getFormattedNumber(data?.final_amount)} {storeCurrency?.currency?.name}</span>
            </BoldRow>
            <Hr />
            <BoldRow>
              <span>{t('paid_with')}:</span>
              <span>{data?.payment_type === "COD" ? "COD" : (data?.payment_type === "AUTO" ? data?.Transactions[0]?.payment_name : data?.payment?.payment_name)}</span>
            </BoldRow>
            <BoldRow>
              <span>{t('customer_name')}:</span>
              <span>{data?.user?.name ?? "-"}</span>
            </BoldRow>
              <Hr />
                {data?.fulfillment_method === "DELIVERY"  ? 
                <p>            
              <strong>{t('deli_to')}: {data?.delivery_address?.address}, {data?.delivery_address?.township?.name?.primary}, {data?.delivery_address?.city?.name?.primary}, {data?.delivery_address?.country?.name?.primary}.</strong><br />
              <strong>Phone: {data?.delivery_address?.phone}</strong>
              <br/>
            </p> :
             <p>            
              <strong>{t('pickup_to')}:  {data?.pickup_address?.pickup_name?.primary}, {data?.pickup_address?.pickup_address?.primary},
                {` ${data?.pickup_address?.township?.name?.primary}, ${data?.pickup_address?.city?.name?.primary}, ${data?.pickup_address?.country?.name?.primary}`}</strong>
              <br />
              <strong>{t('phone')}: {data?.pickup_address?.phone}</strong>
              <br/>
            </p>
              }
            <Hr/>
            <Center>
              <p>{t('thank_you')}</p>
            </Center>
          </Receipt>
        </PrintWrapper>
      </div>
      </HiddenInUI>
      <Topbar>
        <Button type="default" icon={<IconLeft />} onClick={goBack}>
          {t('back')}
        </Button>
        <TitleWrapper>
          <GrayTitle>{t('orders')}</GrayTitle>
          <IconRight />
          <Title>{t('order_details')}</Title>
        </TitleWrapper>
        {(loading === false && !["CANCELLED","PENDING","UNPAID"].includes(data?.status)) && (
          <>
                <Button
                style={{width:"150px", height:"56px"}}
            onClick={previewReceipt}
            type="default"
            icon={<PrinterFilled />}
          >
            {t('preview')}
          </Button>
          </>
        )}
        {checkQR && (
          <div style={{ display: "flex", gap: "12px" }}>
            <button
              type="button"
              onClick={handleDownloadQR}
              disabled={qrLoading}
              style={{
                backgroundColor: "#1859FF",
                cursor: qrLoading ? "not-allowed" : "pointer",
                display: "flex",
                gap: "8px",
                alignItems: "center",
                fontSize: "16px",
                lineHeight: "26px",
                fontWeight: "700",
                justifyContent: "center",
                color: "#fff",
                border: "none",
                outline: "none",
                borderRadius: "8px",
                width: "170px",
                height: "48px",
                opacity: qrLoading ? 0.7 : 1,
              }}
            >
              <IconDownloadQR />
              {qrLoading ? t("loading") : t("download_qr")}
            </button>

            <button
              type="button"
              onClick={handleGenerateQR}
              disabled={qrLoading}
              style={{
                backgroundColor: "#fff",
                border: "1px solid #B9B9B9",
                cursor: qrLoading ? "not-allowed" : "pointer",
                display: "flex",
                gap: "8px",
                alignItems: "center",
                fontSize: "16px",
                lineHeight: "26px",
                fontWeight: "700",
                justifyContent: "center",
                color: "#000",
                outline: "none",
                borderRadius: "8px",
                width: "160px",
                height: "48px",
                opacity: qrLoading ? 0.7 : 1,
              }}
            >
              <IconQRCode />
              {t("view_qr")}
            </button>
          </div>
        )}
      </Topbar>
       
      {loading ? (
        <Loader />
      ) : (
        <>
          {(["CANCELLED","COMPLETED"].includes(data?.status)) && statusParam === "REFUNDED" ? (
          <RefundedStatusBox status={status} refundedStatus={(data?.payment_type === "AUTO" && data?.base_refund_amount > 0)}  />
        ) : data?.status === ORDER_STATUS.CANCELLED ? (
          <CancelledStatusBox
            status={status}
            cancel_reason={data?.cancellation_reason?.primary}
            cancelled_by={data?.cancelled_by}
            cancelType={data?.cancel_type}
          />
        ) : (
          <StatusBox status={status} />
        )}
        {data?.has_delivery_request === true &&
           <Card style={{ display: "flex", justifyContent: "space-between",height:"110px", backgroundColor:"#ECFAE6",alignItems:"center"}}>
            {/* <Descriptions column={1} items={items} /> */}
            <Space direction="vertical">
                <h3 style={{fontSize:"18px",lineHeight:"28px",fontWeight:"600",color:"#319300"}}>{t('admin_request_deli')}</h3>
                <div style={{display:"flex",alignItems:"center",gap:"20px"}}>
                  <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
                    <IconCarDelivery/>
                    <h3 style={{fontSize:"16px",lineHeight:"26px",fontWeight:"500",color:"#191114"}}>{data?.delivery_system?.name}</h3>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
                    <IconPhoneDeli/>
                    <h3 style={{fontSize:"16px",lineHeight:"26px",fontWeight:"500",color:"#191114"}}>{data?.delivery_system?.phone}</h3>
                  </div>
                </div>
            </Space>
             <Button
                  type="primary"
                  icon={<IconCheckLight />}
                  onClick={() => setOpen(true)}
                >
                  {t('view_req')}
                </Button>
          </Card>}
          {(["CANCELLED","COMPLETED"].includes(data?.status)) && (data?.base_refundable_amount > 0 && data?.payment_type === "AUTO") &&
          <div style={{width:"100%",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div></div>
          <Button style={{width:"fit", height:"56px"}}
                  type="primary"
                  icon={<IconCheckLight />}
                  onClick={() => setOpenRefundModal(true)}
                >
                  {t('refund_order')}
            </Button>
            </div>}
          {(data?.payment_type === "AUTO" && data?.base_refund_amount > 0) && (
            <Alert
              message={`${t('order_refunded_text')}`}
              type="warning"
              showIcon
            />
          )}
          <Card style={{ display: "flex", justifyContent: "space-between" }}>
            {/* <Descriptions column={1} items={items} /> */}
            <Space direction="vertical">
              {items?.map((item, idx) => (
                <NormalText key={idx}>
                  {item.label}: {item.children}
                  {(idx === 1 || idx === 2)&& (
                    <CopyOutlined
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCopy(item.children);
                      }}
                      style={{
                        cursor: "pointer",
                        color: "gray",
                        paddingLeft: "4px",
                      }}
                    />
                  )}
                </NormalText>
              ))}
            </Space>
            {(params?.status === "DELIVERY_ORDER" && data?.has_delivery_request === false) ? 
             <Space>
            <Button disabled={data?.has_delivery_request} type="default" onClick={handleCancelClicked}>
              {t('cancel_order')}
            </Button>
            <Button
              type="primary"
              icon={<IconCheckLight />}
              onClick={() => setDeliveryModalOpen(true)}
            >
              {t('req_deli')}
            </Button>
          </Space>
             :
            <ActionButtons status={data?.status} />}
          </Card>
       
          <Row gutter={[20, 20]}>
            <Col xs={24} md={12}>
            {data?.fulfillment_method === "PICKUP" ?
              <Card>
                <Space direction="vertical">
                  <BoldText>{t("pickup_address")}</BoldText>

                  <Space style={{ alignItems: "flex-start" }}>
                    <Avatar
                      shape="square"
                      icon={<IconPerson />}
                      className="custom-avatar"
                    />

                    <div>
                      <Space>
                        <BoldText>
                          {getLocalizedValue(
                            data?.pickup_address?.pickup_name,
                            displayLanguage
                          )}
                        </BoldText>
                      </Space>

                      <NormalText>
                        {data?.pickup_address?.phone ?? "-"}
                      </NormalText>

                      <GrayText>
                        {`${getLocalizedValue(
                          data?.pickup_address?.township?.name,
                          displayLanguage
                        )}, ${getLocalizedValue(
                          data?.pickup_address?.city?.name,
                          displayLanguage
                        )}, ${getLocalizedValue(
                          data?.pickup_address?.country?.name,
                          displayLanguage
                        )}`}
                      </GrayText>

                      <GrayText>
                        {getLocalizedValue(
                          data?.pickup_address?.pickup_address,
                          displayLanguage
                        )}
                      </GrayText>

                      <GrayTextHref
                        href={mapLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {data?.pickup_address?.map_link ?? "-"}
                      </GrayTextHref>
                    </div>
                  </Space>
                </Space>
              </Card>
             : <Card>
                <Space direction="vertical">
                  <BoldText>{t('deli_address')}</BoldText>
                  <Space style={{ alignItems: "flex-start" }}>
                    <Avatar
                      shape="square"
                      icon={<IconPerson />}
                      className="custom-avatar"
                    />
                    {data?.delivery_address === null
                     ? <GrayText> {t('no_deli_address')}</GrayText> : 
                    <div>
                      <Space>
                        <BoldText>{data?.delivery_address?.receiver_name}</BoldText>
                      </Space>
                      <NormalText>{data?.delivery_address?.phone}</NormalText>
                      <GrayText>
                        {fullAddress ? `${fullAddress}` : "-"}
                      </GrayText>
                    </div>
                      }
                  </Space>
                </Space>
              </Card>}
            </Col>
            <Col xs={24} md={12}>
            {data?.payment_type === "AUTO" ?  
            <Card>
                <Space direction="vertical" style={{ flex: 1 }}>
                  <BoldText>{t('payment_method')}</BoldText>
                  <Space>
                    <Avatar style={{width:"40px",height:"40px",borderRadius:"8px"}} shape="square" src={data?.Transactions[0]?.payment_logo} />
                    {/* <NormalText>{data?.Transactions[0]?.payment_type}</NormalText> */}
                    <NormalText>
                      {(data?.Transactions[0]?.payment_type === "KBZPay" && data?.Transactions[0]?.payment_method === "mmqr") ? "KBZPay MMQR" : data?.Transactions[0]?.payment_type}
                    </NormalText>
                  </Space>
                  {data?.Transactions[0]?.payment_type !== "WAVEPay" &&
                   <div style={{display:"flex",flexDirection:"column",alignItems:"start",gap:"0px",marginTop:"10px"}}>
                   <BoldText>{t('payment_type')}</BoldText>
                   <NormalText>{data?.payment_type}</NormalText>
                  </div>}
                </Space>
                {!!data?.screenshot && (
                  <Image src={data?.screenshot} className="ss-image" />
                )}
              </Card>
            :
              <Card>
                <Space direction="vertical" style={{ flex: 1 }}>
                  <BoldText>{t('payment_method')}</BoldText>
                  <Space>
                    {data?.payment_type === "COD" ? <IconCOD/> : 
                    <Avatar shape="square" src={data?.payment?.payment_logo} />}
                    {/* <NormalText>{data?.payment?.payment_name}</NormalText> */}
                     <NormalText>
                      {(data?.payment?.payment_type === "KBZPay" && data?.payment?.payment_method === "mmqr") ? "KBZPay MMQR" : data?.payment?.payment_name}
                      </NormalText>
                  </Space>
                   <div style={{display:"flex",flexDirection:"column",alignItems:"start",gap:"0px",marginTop:"10px"}}>
                   <BoldText>{t('payment_type')}</BoldText>
                   <NormalText>{data?.payment_type}</NormalText>
                  </div>
                </Space>
                {!!data?.screenshot && (
                  <Image src={data?.screenshot} className="ss-image" />
                )}
              </Card>
              }
            </Col>
          </Row>
          <BoldText>{t('order_summary')}</BoldText>
          {data?.is_delivery_free === true &&
          <DeliDiv>
           <div style={{display:"flex",alignItems:"center"}}>
            <IconDeliFree style={{minWidth:"80px",minHeight:"80px"}}/>
            <h3 style={{fontSize:"14px",fontWeight:"400",color:"#191114",marginLeft:"-10px"}}>
               <Trans
                i18nKey={data?.deli_fee_qualification_type === "PER_ORDER" ? "per_order_free_delivery_message" : "acc_spending_free_delivery_message"} 
                components={{
                  bold: <b />,
                }}
              />
            </h3>
           </div>
           <div>
            <h3 style={{fontSize:"14px",fontWeight:"700",color:"#191114"}}>{getFormattedNumber(data?.deli_free_amount)}/ <span style={{fontSize:"14px",fontWeight:"700",color:"#CB8600"}}>{getFormattedNumber(data?.deli_free_amount)} {storeCurrency?.currency?.name}</span></h3>
           </div>
          </DeliDiv>}
          <Card>
            <div style={{ width: "100%" }}>
              <Row gutter={[0, 8]}>
                <Col xs={12}>
                  <NormalText>{t('total_products')}</NormalText>
                </Col>
                <Col xs={12} style={{ textAlign: "right" }}>
                  <NormalText>
                      {data?.product_count - data?.cancel_count}
                  </NormalText>
                </Col>
                <Col xs={12}>
                  <NormalText>{t('total_price')}</NormalText>
                </Col>
                <Col xs={12} style={{ textAlign: "right" }}>
              <NormalText>
                MMK {getFormattedNumber(data?.base_total_price)}{" "}
                {storeCurrency?.currency?.name !== "MMK" && (
                  <>
                    {" "}
                    ({storeCurrency?.currency?.name}{" "}
                    {getFormattedNumber(data?.total_price)})
                  </>
                )}
              </NormalText>
                </Col>
                {data?.cod_fee > 0 &&
                <>
                <Col  style={{cursor:"pointer"}} xs={3}>
                  <Popover
                  content={totalPriceContent}
                  trigger="hover"
                  placement="top"
                  overlayClassName="premium-popover"
                 
                >
                  <NormalText style={{display:"flex",alignItems:"center",gap:"6px",whiteSpace:"nowrap"}}>
                    {t("additional_cod")}
                    <CircleInformation
                      size={16}
                      className="text-gray-400 transition-all duration-200 hover:text-blue-500"
                    />
                  </NormalText>
                </Popover>
                </Col>
                <Col xs={21} style={{ textAlign: "right" }}>
                <NormalText>
                  MMK {getFormattedNumber(data?.base_cod_fee)}{" "}
                  {storeCurrency?.currency?.name !== "MMK" && (
                    <>
                      {" "}
                      ({storeCurrency?.currency?.name}{" "}
                      {getFormattedNumber(data?.cod_fee)})
                    </>
                  )}
                </NormalText>
                </Col>
                </>
                }
                {(data?.Transactions.length > 0 && Number(data?.Transactions[0]?.charge_per_transaction) > 0 && data?.cancelled_by === null) &&
                <>
                <Col xs={12}>
                  <NormalText>{t('tran_fee')}</NormalText>
                </Col>
                <Col xs={12} style={{ textAlign: "right" }}>
                  <NormalText style={{color:"#FF3F33"}}>
                    {data?.Transactions[0]?.charge_method === "PERCENT" ? `${getFormattedNumber(
                      data?.Transactions[0]?.charge_per_transaction || 0
                    )} %`
                    :  `- MMK ${getFormattedNumber(
                      data?.Transactions[0]?.charge_per_transaction || 0
                    )}`}
                  </NormalText>
                </Col>
                </>}
                <Divider/>
                <Col xs={12}>
                  <NormalText>{t('final_income')}</NormalText>
                </Col>
                <Col xs={12} style={{ textAlign: "right" }}>
                <PrimaryText>
                MMK {getFormattedNumber(base_final_income_amount)}{" "}
                {storeCurrency?.currency?.name !== "MMK" && (
                  <>
                    {" "}
                    ({storeCurrency?.currency?.name}{" "}
                    {getFormattedNumber(final_income_amount)})
                  </>
                )}
              </PrimaryText>
                </Col>
                {data?.cancel_count > 0 && (
                  <>
                    <Row
                      gutter={[0, 16]}
                      style={{
                        width: "100%",
                        backgroundColor: "white",
                        padding: "2px 8px",
                        borderRadius: "8px",
                      }}
                    >
                      <Col xs={12}>
                        <GrayText>{t('customer_paid')}</GrayText>
                      </Col>
                      <Col xs={12} style={{ textAlign: "right" }}>
                        <NormalText>
                          MMK {getFormattedNumber(data?.base_customer_paid)}{" "}
                          {storeCurrency?.currency?.name !== "MMK" && (
                            <>
                              {" "}
                              ({storeCurrency?.currency?.name}{" "}
                              {getFormattedNumber(data?.customer_paid)})
                            </>
                          )}
                        </NormalText>
                      </Col>
                    </Row>
                    <Row
                      gutter={[0, 16]}
                      style={{
                        width: "100%",
                        backgroundColor: "white",
                        padding: "2px 8px",
                        borderRadius: "8px",
                      }}
                    >
                      <Col xs={12}>
                        <GrayText>{t('price_unavailable')}</GrayText>
                      </Col>
                      <Col xs={12} style={{ textAlign: "right" }}>
                     <NormalText style={{ color: "#f00" }}>
                          - MMK {getFormattedNumber(base_cancelled_amount)}{" "}
                          {storeCurrency?.currency?.name !== "MMK" && (
                            <>
                              {" "}
                              (-{storeCurrency?.currency?.name}{" "}
                              {getFormattedNumber(cancelled_amount)})
                            </>
                          )}
                        </NormalText>
                      </Col>
                    </Row>
                    {data?.payment_type !== "COD" &&
                    <GrayText style={{ whiteSpace: "nowrap" }}>
                      {t('customer_refunded')}{" "}
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        {getFormattedNumber(data?.base_refund_amount)} MMK
                      </span>{" "}
                     {t('we_will_touch')}
                    </GrayText>}
                  </>
                )}
              </Row>
            </div>
          </Card>
    <Row gutter={[16, 16]}>
          {data?.OrderProducts?.map((product, key) => (
            <Col xs={24} md={12} key={key}>
              <Card>
                <Avatar
                  shape="square"
                  size={100}
                  src={
                    product.product.has_variant
                      ? product.variant.image_url
                      : product.product.thumb_image
                  }
                />

                <Space direction="vertical" style={{ flex: 1 }}>
                  {/* SKU + Details */}
                  <Row>
                    <Col xs={20}>
                      <GrayText
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCopy(product?.product?.sku);
                        }}
                        style={{
                          cursor: "pointer",
                          color: "gray",
                          paddingLeft: "4px",
                        }}
                      >
                        {product?.product?.sku}{" "}

                        <CopyOutlined
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCopy(product?.product?.sku);
                          }}
                          style={{
                            cursor: "pointer",
                            color: "gray",
                            paddingLeft: "4px",
                          }}
                        />
                      </GrayText>
                    </Col>

                    <Col
                      xs={4}
                      style={{ textAlign: "right" }}
                      onClick={() =>
                        goToProductDetails(product?.product?.id)
                      }
                    >
                      <IconRight className="icon-right" />
                    </Col>
                  </Row>

                  {/* Localized Product Name */}
                  <NormalText>
                    {getLocalizedValue(
                      product?.product?.name,
                      displayLanguage
                    )}
                  </NormalText>

                  {/* Variant Options */}
                  <Flex wrap>
                    {product?.variant?.ProductVariantCombinations?.map(
                      (v, key) => (
                        <Tag
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "none",
                            padding: "4px 8px",
                            fontWeight: 500,
                          }}
                          key={key}
                        >
                          {v.variant_value?.name}
                        </Tag>
                      )
                    )}
                  </Flex>

                  {/* Quantity + Price */}
                  <Row>
                    <Col xs={12}>
                      <NormalText>
                        {`${t("qty")}: ${getFormattedNumber(
                          product.quantity
                        )}`}
                      </NormalText>
                    </Col>

                    <Col xs={12} style={{ textAlign: "right" }}>
                      <BoldText>
                        {getFormattedNumber(product.price)}
                      </BoldText>
                    </Col>
                  </Row>

                  {/* Cancellation Reason */}
                  {product?.is_cancel && (
                    <CancelledText>
                      <Flex
                        justify="space-between"
                        align="center"
                        gap={12}
                      >
                        <span>
                          {getLocalizedValue(
                            product?.cancellation_reason,
                            displayLanguage
                          )}
                        </span>

                        <span
                          style={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          {" "}
                          - {product?.total_price}
                        </span>
                      </Flex>
                    </CancelledText>
                  )}
                </Space>
              </Card>
            </Col>
          ))}
        </Row>
        </>
      )}
      <CheckModal
        open={openCheck}
        id={id}
        total_price={data?.total_price}
        products={data?.OrderProducts}
        setData={setData}
        handleClose={() => setOpenCheck(false)}
        successCallback={successCallback}
        productCount={data?.product_count}
      />

      <PickupModal
        open={openPickupModal}
        id={id}
        final_amount={data?.final_amount}
        products={data?.OrderProducts}
        handleClose={handlePickupClose}
        successCallback={successCallback}
      />

      <RejectReasonModal
        id={id}
        p_id={product.id}
        variant_id={product.variant_id}
        product_id={product.product_id}
        type={cancelType}
        open={openRejectReasonModal}
        handleClose={handleRejectReasonClose}
        successCallback={successCallback}
      />

      <RejectModal
        id={id}
        open={openRejectModal}
        handleClose={handleRejectClose}
        successCallback={successCallback}
      />
      <DeliRequestModal
        open={open}
        handleClose={() => setOpen(false)}
        order={data}
      />
      <DeliveryRequestModal
            open={deliveryModalOpen}
            handleClose={() => setDeliveryModalOpen(false)}
            order={data} 
            successCallback={successCallback}
            />
      <RefundConfirmModal
        id={id}
        open={openRefundModal}
        handleClose={handleRefundClose}
        successCallback={successCallback}
        refundAmount={data?.base_refundable_amount}
        currencyName={storeCurrency?.currency?.name}
      />
      <ViewQRReceiptModal
          open={qrModalOpen}
          handleClose={() => setQrModalOpen(false)}
          orderId={id}
          order={data}
          businessInfo={businessInfoData}
          currencyName={storeCurrency?.currency?.name}
          qrImage={qrImage}
        />
    </RootContainer>
  );
};

export default OrderDetails;
